import React, { useEffect, useRef, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { clientPath } from "../../config/key";
import {
  diamondColorDispersion,
  diamondColorInnerGrade,
  diamondColorUndertone,
  diamondDepth,
  diamondDepthForManual,
} from "../../utils/diamondData";
import Header from "../header/header";
import "./result.css";
import infoIcon from "../../assets/images/pricing/info-icon.svg";
import closeIcon from "../../assets/images/pricing/cross-icon.svg";
import { priceIntelligenceInstance } from "../../config/axios";
import {
  calculateThreePercentLess,
  getPolishAndSymmetryValue,
} from "../../utils/function";
import { useLocation, useNavigate } from "react-router-dom";
import DesktopPairType from "../pricing/desktopPairType";
import InfoModal from "../infoModal/infoModal";
import { PriceIntelligence } from "../../utils/dataPI";
import ErrorModal from "../ErrorModal/errorModal";
import { UAParser } from 'ua-parser-js';
import Footer from "../footer/footer";
import DiamondLoader from "../diamondLoader/DiamondLoader";
import AdjustIdu from "./AdjustIdu";


const DiamondShapes = [
  { id: 1, img: "radient", value: "Radiant" },
  { id: 2, img: "cushion", value: "Cushion" },
  { id: 3, img: "oval", value: "Oval" },
  { id: 4, img: "heart", value: "Heart" },
  { id: 5, img: "pear", value: "Pear" },
  { id: 6, img: "emerald", value: "Emerald" },
  { id: 7, img: "round", value: "Round" },
  { id: 8, img: "marquise", value: "Marquise" },
  { id: 9, img: "hexagon", value: "Hexagon" },
  { id: 10, img: "triangular-brilliant", value: "Triangular Brilliant" },
  { id: 11, img: "octagon", value: "Octagon" },
  { id: 12, img: "princess", value: "Princess" },
  { id: 13, img: "trilliant", value: "Trilliant" },
  { id: 14, img: "kite", value: "Kite" },
  { id: 15, img: "shield", value: "Shield" },
];

const getShapeForImage = (shape) => {
  const item = DiamondShapes.find((item) => shape === item.value);
  return item ? item.img : "";
};

const DesktopResult = () => {
  const ref = useRef(null);
  
  const location = useLocation();
  const { id, checkAsset, pricetepData, reportType } = location.state ?? {};
  if ( !pricetepData) {
    window.location.href = "/start-pricing";
  }
  const { price, jobNumber } = pricetepData;
  const [loading, setLoading] = useState(false);
  const [previousData, setPreviousData] = useState(pricetepData);
  const [errMsg, setErrMsg] = useState("");
  const [errorModal, setErrorModal] = useState(false);
  const navigate = useNavigate();
  const [pricestepData, setPricestepData] = useState(pricetepData);
  const [checkAssets, setCheckAssets] = useState(checkAsset);
 

  useEffect(() => {
    setPreviousData(pricetepData);
    setPricestepData(pricetepData);
  }, [pricetepData]);

  

  const handleClick = () => {
    window.location.href = "/start-pricing";
  };
  const [iduPopupOpen, setIduPopupOpen] = useState(false);
  const [iduMobPopupOpen, setIduMobPopupOpen] = useState(false);

  

  const handlIduPopup = () => {
    setIduPopupOpen(true);
  };

  const handlIduPopupMob = () => {
    setIduMobPopupOpen(true);
  };

  const calculatePrice = async () => {
    try {
      if (
        previousData?.colorDispersion === pricestepData?.colorDispersion &&
        previousData?.colorInnerGrade === pricestepData?.colorInnerGrade &&
        pricestepData?.colorUndertone === previousData?.colorUndertone &&
        previousData?.trueFaceUp === pricestepData?.trueFaceUp &&
        previousData?.singlePair === pricestepData?.singlePair
      ) {
        setIduPopupOpen(false);
        setIduMobPopupOpen(false);
        return;
      }

      if (
        checkAssets &&
        (previousData?.colorDispersion !== pricestepData?.colorDispersion ||
          previousData?.colorInnerGrade !== pricestepData?.colorInnerGrade ||
          pricestepData?.colorUndertone !== previousData?.colorUndertone)
      ) {
        setCheckAssets(false);
      }
      setIduPopupOpen(false);
      setIduMobPopupOpen(false);
      setLoading(true);

      const payload = { ...previousData };
      setPricestepData({ ...pricestepData });
      let { polish, symmetry } = payload || {};
      if (polish === "Default") {
        payload.polish = "Vg";
        payload.symmetry = "G";
        polish = "Vg";
        symmetry = "G";
      }

      payload.polishAndSymmetry = getPolishAndSymmetryValue(polish, symmetry);

      const depthItem = (
        reportType === "byGia" ? diamondDepth : diamondDepthForManual
      ).find((item) => item.displayName === pricestepData.trueFaceUp);

      if (depthItem) {
        // Update the payload with the Id from the depthItem
        payload.trueFaceUp = Number(depthItem.Id);
      }

      if (Number(previousData?.colorInnerGrade) === 5) {
        payload.colorInnerGrade = "4+";
      }

      // console.log("payload", previousData.colorUndertone);

      if (
        Number(previousData.colorUndertone) > 4 &&
        previousData?.color === "Yellow" &&
        previousData?.saturation !== "Fancy Deep"
      ) {
        payload.colorUndertone = String(
          8 - Number(previousData.colorUndertone)
        );
      }
      if (
        Number(previousData.colorUndertone) === 5 &&
        pricestepData?.color !== "Yellow"
      ) {
        payload.colorUndertone = "4+";
      }
      if (Number(previousData.colorDispersion) === 5) {
        payload.colorDispersion = "4+";
      }
      if (
        pricestepData?.saturation === "Fancy Deep" &&
        previousData.colorUndertone === "2"
      ) {
        payload.colorUndertone = "3";
      }
      const [ipResponse, uaResult] = await Promise.all([
        fetch("https://api.ipify.org?format=json"),
        new Promise((resolve) => resolve(new UAParser().getResult())),
      ]);
  
      const { ip } = await ipResponse.json();
  
      // Prepare the payload for the API
      const extraInfo = {
        IP: ip,
        "Operating System": uaResult.os.name,
        Browser: uaResult.browser.name,
        Device: uaResult.device.model || "Unknown",
      };
      const response = await priceIntelligenceInstance().post(
        `/price/getreport`,
        { payload, recalculate: true, id: id, checkAssets , extraInfo}
      );
    
      setTimeout(() => {
        setLoading(false);
      }, 4500);
      const { status, msg, price, jobNumber, pdfurl } = response?.data || {};
      if (status === 200) {
        let priceValue = price;
        // if (pricestepData?.giasaturation === "Fancy Deep") {
        //   priceValue = price * 0.94;
        // }
        setPricestepData({
          ...pricestepData,
          ...payload,
          price: calculateThreePercentLess(priceValue, checkAssets),
          jobNumber,
          pdfurl,
        });
        const exportData = {
          ...pricestepData,
          ...payload,
          price: calculateThreePercentLess(priceValue, checkAssets),
          jobNumber,
          pdfurl,
        };

        setTimeout(() => {
          navigate("/result", {
            state: {
              id,
              checkAsset: false,
              pricetepData: exportData,
              reportType: reportType,
            },
          });
        }, 4500);
      } else if (status === 400) {
        return;
      } else {
        setPricestepData({ ...pricestepData, price: 0 });
        setErrMsg(msg);
      }
    } catch (error) {}
  };

  const handleValueClick = async () => {
    try {
      // Open the PDF URL immediately to avoid popup blockers
      const newTab = window.open(pricestepData?.pdfurl, "_blank");
      
      if (!newTab) {
        alert("Please allow popups to view the PDF.");
        return;
      }
  
      // Proceed with the asynchronous operations
      // const formattedDate = new Date().toLocaleString("he-IL", {
      //   day: "numeric",
      //   month: "numeric",
      //   year: "numeric",
      //   hour: "numeric",
      //   minute: "numeric",
      //   hour12: false,
      //   timeZone: "Asia/Jerusalem",
      // }).replace(",", "");
      
      // const ua = navigator.userAgent;
      // const [ipResponse, uaResult] = await Promise.all([
      //   fetch('https://api.ipify.org?format=json'),
      //   new Promise(resolve => resolve(new UAParser(ua).getResult()))
      // ]);
      
      // const { ip } = await ipResponse.json();
      
      const payload = {
        auctionDetails:{
          action: 'Export',
          Id: `#PI${pricestepData?.jobNumber}`,
          tool: 'Price Intelligence',
          status: 'Success',
          giaNumber: pricestepData?.giaReportNumber
        },
        links:{
          pdfUrl: pricestepData?.pdfurl,
        }
        // services: {
        //   IP: ip,
        //   'Operating System': uaResult.os.name,
        //   Browser: uaResult.browser.name,
        //   Device: uaResult.device.model || 'Unknown',
        // },
      };
      
      await priceIntelligenceInstance().post(`price/send-pi-webhook`, payload);
    } catch (error) {
      console.error("An error occurred", error);
    }
  };
  
  

  const formatDate = () => {
    const today = new Date();

    const day = today.getDate();
    const month = today.getMonth() + 1
    const year = today.getFullYear().toString();
    const months = [
      'Jan', 'Feb', 'Mar' , 'Apr' , 'May', "Jun" , 'Jul' , 'Aug' , 'Sep','Oct', 'Nov' , 'Dec'
    ]

    const formattedDate = `${months[month - 1]} ${day}, ${year}`;

    return formattedDate;
  };


  

  const priceData = price === 0 ? 0 : price?.split("-");
  function getScaleForImage(shape, ratio) {
    if (!shape || !ratio) return 1.0;
  
    const scaleMap = {
      Cushion: [
        { upto: 1.09, scale: 1 },
        { upto: 1.19, scale: 1.05 },
        { upto: 1.29, scale: 1.1 },
        { upto: Infinity, scale: 1.15 },
      ],
      Radiant: [
        { upto: 1.09, scale: 1 },
        { upto: 1.19, scale: 1.05 },
        { upto: 1.29, scale: 1.1 },
        { upto: Infinity, scale: 1.15 },
      ],
      Oval: [
        { upto: 1.29, scale: 0.75 },
        { upto: 1.39, scale: 0.83 },
        { upto: 1.44, scale: 0.91 },
        { upto: Infinity, scale: 1 },
      ],
      Heart: [
        { upto: 0.99, scale: 1 },
        { upto: 1.04, scale: 1.05 },
        { upto: Infinity, scale: 1.1 },
      ],
 
      Pear: [
        { upto: 1.39, scale: 1 },
        { upto: 1.49, scale: 1.05 },
        { upto: 1.59, scale: 1.1 },
        { upto: Infinity, scale: 1.15 },
      ],
      Emerald: [
        { upto: 1.19, scale: 0.65 },
        { upto: 1.29, scale: 0.78 },
        { upto: 1.39, scale: 0.91 },
        { upto: Infinity, scale: 1 },
      ],
    };
  
    const shapeData = scaleMap[shape];
    if (!shapeData) return 1.0;
    const ratioData = shapeData.find((data) => Number(ratio) <= data.upto);
    return ratioData ? ratioData.scale : 1.0;
  }
  return (
    <div className="price-intelligence-layout">
      <div className="start-pricing">
      <div className="fixed-center-issue">
        <div>

        {!loading && <Header title="new-header" type="result" />}
        {loading ? (
          <div className="desktop-result-screen result-loading">
            <div className="desktop-result-body">
              <LoaderResult />
            </div>
          </div>
        ) : (
          <div className="desktop-result-screen-container">
          <div className="desktop-result-screen">
            <div className="desktop-result-body">
              <div className="desktop-result-top">
                <p>Confidential</p>
                {pricestepData?.giaReportNumber && (
                  <span className="report-with-gia">
                    {"GIA: " + pricestepData?.giaReportNumber}
                  </span>
                )}
                <span>Price ID#: {jobNumber}</span>
              </div>
              <div className="desktop-result-mid">
                <div className={`diamond_result_img ${pricestepData?.shape === "Pear" && "diamond_result_img_pear"}`} style={{ 
                      transform:`scaleY(${getScaleForImage(pricestepData?.shape, pricestepData?.ratio)})`
                    }}>
                  <img
                    alt="logo1"
                    src={`${clientPath}/images/diamond-${pricestepData?.color?.toLowerCase()}-${getShapeForImage(
                      pricestepData?.shape
                    )}.svg`}
                    
                  />
                </div>
                <p style={{
                  fontWeight: 500
                }}>
                  {/* {checkAssets && "Basic mode - "} */}
                   Details:
                </p>
                <p className="diamond-info">
                  <span style={{ whiteSpace: "nowrap" }}>
                    {pricestepData?.carat_weight}ct,
                  </span>{" "}
                  <span style={{ whiteSpace: "nowrap" }}>
                    {pricestepData?.saturation} {pricestepData?.color},
                  </span>{" "}
                  <span style={{ whiteSpace: "nowrap" }}>
                    {pricestepData?.shape},
                  </span>{" "}
                  <span style={{ whiteSpace: "nowrap" }}>
                    {reportType === "byGia" ? pricestepData?.giaclarity :pricestepData?.clarity },
                  </span>{" "}
                  <span style={{ whiteSpace: "nowrap" }}>
                    {`${
                      (reportType === "byGia"
                        ? diamondDepth
                        : diamondDepthForManual
                      ).find(
                        // eslint-disable-next-line
                        (item) => item.Id == pricestepData?.trueFaceUp
                      )?.displayName
                    }`}
                  </span>
                  {", "}
                  {!checkAssets ? (
                    <span style={{ whiteSpace: "nowrap" }}>
                      Inner Grade <b style={{ fontWeight: 600 }}>{pricestepData?.colorInnerGrade}</b>
                      {", "}
                    </span>
                  ) : (
                    <span style={{ whiteSpace: "nowrap" }}>
                      Visual assets - Default
                    
                    </span>
                  )}{" "}
                  {!checkAssets && (
                    <span style={{ whiteSpace: "nowrap" }}>
                      Dispersion <b style={{ fontWeight: 600 }}>{pricestepData?.colorDispersion}</b>
                      {", "}
                    </span>
                  )}{" "}
                  {!checkAssets && (
                    <span style={{ whiteSpace: "nowrap" }}>
                      Undertone <b style={{ fontWeight: 600 }}>{pricestepData?.colorUndertone}</b>
                    </span>
                  )}
                </p>
              </div>
              <div className="desktop-result-last">
                <p>Wholesale Price {!checkAssets ? "- Advance" : "- Basic" }:</p>
                <h6>
                  {priceData?.length > 0
                    ? `${priceData[0]} - ${priceData[1]} `
                    : "0"}{" "}
                  <span>PC</span>
                </h6>
              </div>
              <span className="last-span-text">
                Prices may fluctuate over time with market trends and are also
                contingent upon the accuracy of your input; therefore, they
                should not be considered as a guarantee. While the price range
                reflects values within the trade with a relatively high
                accuracy, we recommend using the prices only as a second
                opinion.
              </span>
              <h6 className="report-text">
                Report generated on {formatDate()} | Last data update on March 15, 2026
              </h6>
              <h6 className="report-text-mobile">
                Report generated on {formatDate()}
              </h6>
              <h6 className="report-text-mobile">
                Last data update on March 15, 2026
              </h6>

              <p className="export_text" onClick={handleValueClick}>
                Export
              </p>
            </div>

            <div className="next-btn-grid next-btn-desk">
              <Button className="next-btn" onClick={handleClick}>
               <span>price another</span>
              </Button>
              <Button
                className="next-btn adu-btn adu-btn-desk"
                onClick={handlIduPopup}
              >
               <span>Adjust IDU</span>
              </Button>
            </div>

            <div className="next-btn-grid next-btn-mob">
              <Button className="next-btn" onClick={handleClick}>
                price another
              </Button>
              <Button
                className="next-btn adu-btn adu-btn-mob"
                onClick={handlIduPopupMob}
              >
                Adjust IDU
              </Button>
            </div>
            <ErrorModal
              errorModal={errorModal}
              setErrorModal={setErrorModal}
              errMsg={errMsg}
              bg_remove_modal="bg_remove_modal"
            />
          </div>
          </div>
        )}
      </div>
      </div>
       </div>
      <AdjustIdu
        show={iduPopupOpen && pricestepData?.saturation !=="Fancy Deep"}
        setIduPopupOpen={setIduPopupOpen}
        pricestepData={previousData}
        setPricestepData={setPreviousData}
        checkAssets={checkAssets}
        calculatePrice={calculatePrice}
        reportType={reportType}
      />
      <IduPopupDesktop
         show={iduPopupOpen && pricestepData?.saturation ==="Fancy Deep"}
        setIduPopupOpen={setIduPopupOpen}
        pricestepData={previousData}
        setPricestepData={setPreviousData}
        checkAssets={checkAssets}
        calculatePrice={calculatePrice}
        reportType={reportType}
      />
      <IduPopupMob
        show={iduMobPopupOpen}
        setIduPopupOpen={setIduMobPopupOpen}
        pricestepData={previousData}
        setPricestepData={setPreviousData}
        checkAssets={checkAssets}
        calculatePrice={calculatePrice}
        reportType={reportType}
        setIduMobPopupOpen={setIduMobPopupOpen}
      />
      <div className="download-pdf-wrapper" ref={ref}>
        <ExportPdf
          pricestepData={pricestepData}
          checkedAssets={checkAssets}
          jobNumber={jobNumber}
          reportType={reportType}
          priceData={priceData}
        />
      </div>
      <Footer />
    </div>
  );
};

export default DesktopResult;

const IduPopupDesktop = ({
  show,
  setIduPopupOpen,
  pricestepData,
  setPricestepData,
  checkAssets,
  calculatePrice,
  reportType,
}) => {
  const [infoPopupData, setInfoPopupData] = useState();

  const [infoModal, setInfoModal] = useState(false);
  function getValueByField(fieldName) {
    setInfoModal(true);
    let infoData = PriceIntelligence.find((item) => item.field === fieldName);
    setInfoPopupData(infoData);
  }
  return (
    <>
      <div className="Idu_desktop_container">
        <Modal
          show={show}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="Idu_popup_container Idu_desktop_outer"
        >
          <Modal.Header>
            <Modal.Title id="contained-modal-title-vcenter" className="col-12">
              <h3 className="mb-0 pb-0">Adjust IDU </h3>
              <p className="mb-0 pb-0 lh-lg	 text-center idu-popup-mode-text">
                Advanced mode
              </p>
              <span
                onClick={() => {
                  setIduPopupOpen(false);
                }}
              >
                <img src={closeIcon} alt="crossIcon" />
              </span>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="Idu_popup">
              <Form.Group
                className={`form-input-wrapper form-input-radiowrapper flex-row gap-51 w-100`}
              >
                <p className="d-flex m-0 align-items-center gap-1">
                  <Button
                    className="btn_info_icon"
                    onClick={() => getValueByField("color Inner-Grade")}
                  >
                    <img
                      src={infoIcon}
                      alt="info_icon"
                      height="25px"
                      width="25px"
                    />
                  </Button>
                  inner - grade
                </p>
                <div className="shapes_container shapes-wd">
                  {diamondColorInnerGrade?.map((item, ind) => {
                    return (
                      <div className="shape_radiobtn">
                        {pricestepData?.saturation !== "Fancy Vivid" &&
                        item === "4+" ? (
                          <></>
                        ) : (
                          <p className="m-0">{item}</p>
                        )}
                        <input
                          type="radio"
                          id="diamond_color_inner"
                          name="diamond_color_inner"
                          hidden={
                            item === "4+" &&
                            pricestepData?.saturation !== "Fancy Vivid"
                          }
                          disabled={
                            (item === "4+" &&
                            pricestepData?.saturation !== "Fancy Vivid") || pricestepData?.saturation === "Fancy Deep"
                          }
                          value={item}
                          checked={pricestepData?.colorInnerGrade === item}
                          onChange={(e) => {
                            setPricestepData({
                              ...pricestepData,
                              colorInnerGrade: item,
                            });
                          }}
                        />
                      </div>
                    );
                  })}
                </div>
              </Form.Group>
              <Form.Group
                className={`form-input-wrapper form-input-radiowrapper flex-row gap-51 w-100`}
              >
                <p className="d-flex m-0 align-items-center gap-1">
                  <Button
                    className="btn_info_icon"
                    onClick={() => getValueByField("color Dispersion")}
                  >
                    <img
                      src={infoIcon}
                      alt="info_icon"
                      height="25px"
                      width="25px"
                    />
                  </Button>
                  Dispersion
                </p>
                <div className="shapes_container shapes-wd">
                  {diamondColorDispersion?.map((item, ind) => {
                    return (
                      <div className="shape_radiobtn">
                        {pricestepData?.shape === "Round" && item === "4+" ? (
                          <></>
                        ) : (
                          <p className="m-0">{item}</p>
                        )}

                        <input
                          type="radio"
                          id="diamond_color_dispersion"
                          name="diamond_color_dispersion"
                          hidden={
                            pricestepData?.shape === "Round" && item === "4+"
                          }
                          value={item}
                          checked={pricestepData?.colorDispersion === item}
                          onChange={(e) => {
                            setPricestepData({
                              ...pricestepData,
                              colorDispersion: item,
                            });
                          }}
                        />
                      </div>
                    );
                  })}
                </div>
              </Form.Group>
              <Form.Group
                className={`form-input-wrapper form-input-radiowrapper flex-row gap-51 w-100`}
              >
                <p className="d-flex m-0 align-items-center gap-1">
                  <Button
                    className="btn_info_icon"
                    onClick={() => getValueByField("color Undertone")}
                  >
                    <img
                      src={infoIcon}
                      alt="info_icon"
                      height="25px"
                      width="25px"
                    />
                  </Button>
                  undertone
                </p>
                <div className="shapes_container shapes-wd">
                  {diamondColorUndertone?.map((item, ind) => {
                    return (
                      <div className="shape_radiobtn">
                        {pricestepData?.color !== "Pink" &&
                        item.value === "4+" ? (
                          <></>
                        ) : (
                          <p className="m-0">{item?.value}</p>
                        )}
                        <input
                          type="radio"
                          id="diamond_color_undertone"
                          name="diamond_color-undertone"
                          value={item.value}
                          hidden={
                            pricestepData?.color !== "Pink" &&
                            item.value === "4+"
                          }
                          disabled={
                            pricestepData?.color !== "Pink" &&
                            item.value === "4+"
                          }
                          checked={
                            pricestepData?.colorUndertone === item?.value
                          }
                          onChange={(e) => {
                            setPricestepData({
                              ...pricestepData,
                              colorUndertone: item?.value
                            });
                          }}
                        />
                      </div>
                    );
                  })}
                </div>
              </Form.Group>
              {reportType === "byGia" ? null : (
                <Form.Group
                  className={`form-input-wrapper form-input-radiowrapper  flex-row gap-51 w-100`}
                >
                  <p className="d-flex m-0 align-items-center gap-1">
                    <Button
                      className="btn_info_icon"
                      onClick={() => getValueByField("TRUE-FACE-UP")}
                    >
                      <img
                        src={infoIcon}
                        alt="info_icon"
                        height="25px"
                        width="25px"
                      />
                    </Button>
                    True Face-Up
                  </p>
                  <div
                    className={`shapes_container shapes-wd ${
                      pricestepData?.shape !== "Round"
                        ? "shapes_face_mr"
                        : "shapes_face_mr_without_round"
                    }`}
                  >
                    {diamondDepthForManual?.map((item, ind) => {
                      return (
                        <div className="shape_radiobtn true_face_up_rc">
                          {pricestepData?.shape === "Round" &&
                          item?.Id === "8" ? (
                            <></>
                          ) : (
                            <p className="m-0">
                              {item.displayName?.includes("Face-Up - ")
                                ? item.displayName.split("Face-Up - ")[1]
                                : item.displayName}
                            </p>
                          )}
                          <input
                            type="radio"
                            id="diamond_face_up"
                            name="diamond_face-up"
                            hidden={
                              item?.Id === "8" &&
                              pricestepData?.shape === "Round"
                            }
                            // eslint-disable-next-line
                            checked={pricestepData?.trueFaceUp == item?.Id}
                            onChange={(e) => {
                              setPricestepData({
                                ...pricestepData,
                                trueFaceUp: parseInt(item?.Id),
                              });
                            }}
                          />
                        </div>
                      );
                    })}
                  </div>
                </Form.Group>
              )}

              <Form.Group
                className={`form-input-wrapper form-input-radiowrapper form-input-newtoggle iduToggle flex-row gap-51 w-100`}
              >
                <p className="d-flex m-0 align-items-center gap-1">
                  <Button
                    className="btn_info_icon"
                    onClick={() => getValueByField("single/pair")}
                  >
                    <img
                      src={infoIcon}
                      alt="info_icon"
                      height="25px"
                      width="25px"
                    />
                  </Button>
                  Single/Pair
                </p>
                <div className="shapes_container">
                  <DesktopPairType
                    name="singlePair"
                    pricestepData={pricestepData}
                    setPricestepData={setPricestepData}
                  />
                </div>
              </Form.Group>
            </div>
            {infoModal && (
              <InfoModal
                infoModal={infoModal}
                setInfoModal={setInfoModal}
                heading={infoPopupData?.field}
                infoTxt={infoPopupData?.info}
                bg_remove_modal="bg_remove_modal"
              />
            )}
          </Modal.Body>
          <Modal.Footer>
            <div className="Idu_Footer">
              <p className="m-0 " role="presentation" onClick={calculatePrice}>
                Re- calculate
              </p>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

const IduPopupMob = ({
  show,
  setIduPopupOpen,
  pricestepData,
  setPricestepData,
  checkAssets,
  calculatePrice,
  reportType,
  setIduMobPopupOpen,
}) => {
  const [, setInfoPopupData] = useState();

  const [, setInfoModal] = useState(false);
  function getValueByField(fieldName) {
    setInfoModal(true);
    let infoData = PriceIntelligence.find((item) => item.field === fieldName);
    setInfoPopupData(infoData);
  }

  const popupRef = useRef(null); // Create a ref to the popup container

  // Function to handle outside click
  const handleClickOutside = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      setIduMobPopupOpen(false);
    }
  };

  
  return (
    <div
      className={`${
        show ? "Idu_popupmob_container_animation" : "Idu_popupmob_container"
      } Idu_popupmob_container `}
      onClick={handleClickOutside}
    >
      <div
        className={`${
          show ? "Idu_popup_container_animation" : "Idu_popup_container"
        } Idu_popup_container`}
        ref={popupRef}
      >
        <div className="p-3">
          <div className="Idu_popup">
            <div className="text-center">
              <h3 className="mb-0 pb-0">Adjust IDU </h3>
              <span className="mb-0 pb-0 lh-lg idu-popup-mode-text">
                Advanced mode
              </span>
            </div>
            <Form.Group
              className={`form-input-wrapper form-input-radiowrapper flex-row gap-51 w-100`}
            >
              <p className="d-flex m-0 align-items-center gap-1">
                <Button
                  className="btn_info_icon"
                  onClick={() => getValueByField("color Inner-Grade")}
                >
                  <img
                    src={infoIcon}
                    alt="info_icon"
                    height="25px"
                    width="25px"
                  />
                </Button>
                inner - grade
              </p>
              <div className="shapes_container shapes-wd">
                {diamondColorInnerGrade?.map((item, ind) => {
                  return (
                    <div className="shape_radiobtn">
                      {pricestepData?.saturation !== "Fancy Vivid" &&
                      item === "4+" ? (
                        <p className="invisible">{item}</p>
                      ) : (
                        <p className="m-0">{item}</p>
                      )}
                      <input
                        type="radio"
                        id="diamond_color_inner_mob"
                        name="diamond_color_inner_mob"
                        hidden={
                          item === "4+" &&
                          pricestepData?.saturation !== "Fancy Vivid"
                        }
                        disabled={
                          item === "4+" &&
                          pricestepData?.saturation !== "Fancy Vivid"
                        }
                        value={item}
                        checked={pricestepData?.colorInnerGrade === item}
                        onChange={(e) => {
                          setPricestepData({
                            ...pricestepData,
                            colorInnerGrade: item,
                          });
                        }}
                      />
                    </div>
                  );
                })}
              </div>
            </Form.Group>
            <Form.Group
              className={`form-input-wrapper form-input-radiowrapper flex-row gap-51 w-100`}
            >
              <p className="d-flex m-0 align-items-center gap-1">
                <Button
                  className="btn_info_icon"
                  onClick={() => getValueByField("color Dispersion")}
                >
                  <img
                    src={infoIcon}
                    alt="info_icon"
                    height="25px"
                    width="25px"
                  />
                </Button>
                Dispersion
              </p>
              <div className="shapes_container shapes-wd">
                {diamondColorDispersion?.map((item, ind) => {
                  return (
                    <div className="shape_radiobtn">
                      {pricestepData?.shape === "Round" && item === "4+" ? (
                        <></>
                      ) : (
                        <p className="m-0">{item}</p>
                      )}
                      <input
                        type="radio"
                        id="diamond_color_dispersion_mob"
                        name="diamond_color_dispersion_mob"
                        hidden={
                          pricestepData?.shape === "Round" && item === "4+"
                        }
                        value={item}
                        checked={pricestepData?.colorDispersion === item}
                        onChange={(e) => {
                          setPricestepData({
                            ...pricestepData,
                            colorDispersion: item,
                          });
                        }}
                      />
                    </div>
                  );
                })}
              </div>
            </Form.Group>

            <Form.Group
              className={`form-input-wrapper form-input-radiowrapper flex-row gap-51 w-100`}
            >
              <p className="d-flex m-0 align-items-center gap-1">
                <Button
                  className="btn_info_icon"
                  onClick={() => getValueByField("color Undertone")}
                >
                  <img
                    src={infoIcon}
                    alt="info_icon"
                    height="25px"
                    width="25px"
                  />
                </Button>
                undertone
              </p>
              <div className="shapes_container shapes-wd">
                {diamondColorUndertone?.map((item, ind) => {
                  return (
                    <div className="shape_radiobtn">
                      {pricestepData?.color !== "Pink" &&
                      item.value === "4+" ? (
                        <></>
                      ) : (
                        <p className="m-0">{item?.value}</p>
                      )}
                      <input
                        type="radio"
                        id="diamond_color-true_faceup_mob"
                        name="diamond_color-true_faceup_mob"
                        checked={pricestepData?.colorUndertone === item?.value}
                        hidden={
                          pricestepData?.color !== "Pink" && item.value === "4+"
                        }
                        onChange={(e) => {
                       
                          if (checkAssets) {
                            setPricestepData({
                              ...pricestepData,
                              colorUndertone: item?.value,
                            });
                          } else {
                            setPricestepData({
                              ...pricestepData,
                              colorUndertone: item?.value,
                            });
                          }
                        }}
                      />
                    </div>
                  );
                })}
              </div>
            </Form.Group>
            {reportType === "byGia" ? null : (
              <Form.Group
                className={`form-input-wrapper form-input-radiowrapper flex-row gap-51 w-100`}
              >
                <p className="d-flex m-0 align-items-center gap-1">
                  <Button
                    className="btn_info_icon"
                    onClick={() => getValueByField("TRUE-FACE-UP")}
                  >
                    <img
                      src={infoIcon}
                      alt="info_icon"
                      height="25px"
                      width="25px"
                    />
                  </Button>
                  True Face-Up
                </p>
                <div
                  className={`shapes_container shapes-wd ${
                    pricestepData?.shape !== "Round"
                      ? "shapes_face_mr_mbl"
                      : "shapes_face_mrtc_without_round_mb"
                  }`}
                >
                  {diamondDepthForManual?.map((item, ind) => {
                    return (
                      <div className="shape_radiobtn">
                        {pricestepData?.shape === "Round" &&
                        item?.Id === "8" ? (
                          <></>
                        ) : (
                          <p className="m-0">
                            {item.displayName?.includes("Face-Up - ")
                              ? item.displayName.split("Face-Up - ")[1]
                              : item.displayName}
                          </p>
                        )}
                        <input
                          type="radio"
                          id="diamond_color_undertone_mob"
                          name="diamond_color-undertone_mob"
                          hidden={
                            item?.Id === "8" && pricestepData?.shape === "Round"
                          }
                          disabled={
                            pricestepData?.color !== "Pink" &&
                            item.value === "4+"
                          }
                       
                          // eslint-disable-next-line
                          checked={pricestepData?.trueFaceUp == item?.Id}
                          onChange={(e) => {
                            setPricestepData({
                              ...pricestepData,
                              trueFaceUp: parseInt(item?.Id),
                            });
                          }}
                        />
                      </div>
                    );
                  })}
                </div>
              </Form.Group>
            )}

            <Form.Group
              className={`form-input-wrapper form-input-newtoggle form-input-radiowrapper flex-row gap-51 w-100`}
            >
              <p className="d-flex m-0 align-items-center gap-1">
                <Button
                  className="btn_info_icon"
                  onClick={() => getValueByField("single/pair")}
                >
                  <img
                    src={infoIcon}
                    alt="info_icon"
                    height="25px"
                    width="25px"
                  />
                </Button>
                Single/Pair
              </p>
              <div className="shapes_container shapes-wd">
                <DesktopPairType
                  name="singlePair"
                  pricestepData={pricestepData}
                  setPricestepData={setPricestepData}
                />
              </div>
            </Form.Group>
          </div>
          <div className="Idu_Footer">
            <p className="m-0 " role="presentation" onClick={calculatePrice}>
              Re- calculate
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

let count = 0;
const LoaderResult = () => {
  const [loaderTxt, setLoaderTxt] = useState("Analyzing characteristics");
  const textAr = ["Assessing price per carat", "Here is the price range"];

  useEffect(() => {
    const interval = setInterval(() => {
      if (count < 2) {
        setLoaderTxt(textAr[count]);
      } else {
        count = 0;
        clearInterval(interval);
      }

      count += 1;
    }, 1500);
    return () => {
      clearInterval(interval);
      count = 0;
    };
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <div class="loaderContainer" bis_skin_checked="1">
        <h6>Price Per Carat:</h6>
        <div className="diamond-animation-loader">
        <DiamondLoader />
      </div>
        <p>{loaderTxt}</p>
      </div>
    </>
  );
};

const ExportPdf = ({
  pricestepData,
  checkAssets,
  jobNumber,
  reportType,
  priceData,
}) => {
  const formatDate = () => {
    const today = new Date();

    // Get the day, month, and year
    const months = [
      'Jan', 'Feb', 'Mar' , 'Apr' , 'May', "Jun" , 'Jul' , 'Aug' , 'Sep','Oct', 'Nov' , 'Dec'
    ]
    const day = today.getDate();
    const year = today.getFullYear().toString();
    const formattedDate = `${months[today.getMonth()]} ${day}, ${year}`;

    return formattedDate;
  };
  return (
    <>
      <div className="pdfOuter">
        <div>
          <h3>
            the fcrf price report<span>©</span>
          </h3>
          <p>Price ID#: 6276762662</p>
        </div>
        <div className="pdf_card">
          <p
            style={{
              fontWeight: 600,
            }}
          >
            Confidential
          </p>
          {pricestepData?.giaReportNumber && (
            <div className="giaPdfNumber">
              <span>{"GIA: " + pricestepData?.giaReportNumber}</span>
            </div>
          )}

          <div className="card_diamond">
            <img
              src={`${clientPath}/images/diamond-${pricestepData?.color?.toLowerCase()}-${getShapeForImage(
                pricestepData?.shape
              )}.svg`}
              height="100%"
              width="100%"
              alt="diamond"
            />
          </div>
          <div className="card_detail">
            <p>
              {" "}
              {!checkAssets ? "Advanced mode - " : "Basic mode - "} Detail:
            </p>
            <span>
              {pricestepData?.carat_weight}ct,
              {pricestepData?.saturation} {pricestepData?.color},
              {pricestepData?.shape},{pricestepData?.clarity},
              {`${
                (reportType === "byGia"
                  ? diamondDepth
                  : diamondDepthForManual
                ).find(
                  // eslint-disable-next-line
                  (item) => item.Id == pricestepData?.trueFaceUp
                )?.displayName
              }`}
              {", "}
              {!checkAssets
                ? "Inner Grade" + pricestepData?.colorInnerGrade
                : "Visual assets - Default"}{" "}
              {!checkAssets && "Dispersion" + pricestepData?.colorDispersion}{" "}
              {!checkAssets &&
                "Undertone" + pricestepData?.colorUndertone + ", "}
            </span>

            <p>Wholesale Price:</p>
            <h4>
              {priceData?.length > 0
                ? `${priceData[0]} - ${priceData[1]}`
                : "0"}

              <span>PC</span>
            </h4>

            <span className="card_detail_data">
              Prices may fluctuate over time with market trends and are also
              contingent upon the accuracy of your input; therefore, they should
              not be considered as a guarantee. While the price range reflects
              values within the trade with a relatively high accuracy, we
              recommend using the prices only as a second opinion.
            </span>
            <h6>
              Report generated on {formatDate()} | Last data update on March 15, 2026
            </h6>
          </div>
        </div>

        <div className="fc-stamp1 pdf-footer-logo">
        
          <svg
            width="266"
            height="266"
            viewBox="0 0 266 266"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M133 0c35.528 0 68.927 13.836 94.05 38.955C252.168 64.078 266 97.477 266 133.005c0 35.523-13.832 68.926-38.95 94.045-25.123 25.118-58.522 38.954-94.05 38.954s-68.927-13.836-94.045-38.954C13.832 201.93 0 168.528 0 133.004c0-35.527 13.832-68.926 38.955-94.05C64.073 13.837 97.472 0 133 0zm0 3.796C61.642 3.796 3.791 61.642 3.791 133.004c0 71.358 57.851 129.209 129.209 129.209s129.209-57.85 129.209-129.209C262.209 61.642 204.358 3.796 133 3.796zm21.555 230.067.097.606c-.97.224-1.325.566-1.277 1.325.017.588.03 1.374.272 2.91l.566 3.646c.175 1.137.263 1.462.658 1.813.378.368.803.447 1.545.399l.096.61-3.23.5-7.859-6.622-.066.013.474 3.072c.242 1.536.474 2.34.588 2.84.202.737.615.978 1.9.846l.097.61-4.257.663-.096-.61c.935-.197 1.264-.483 1.229-1.299-.031-.548-.057-1.387-.294-2.923l-1.076-6.924.834-.132 8.614 7.561.053-.009-.614-3.927c-.237-1.536-.444-2.29-.58-2.804-.206-.755-.552-1.04-1.851-.891l-.097-.61 4.274-.663zm-48.85-1.566 5.3 1.505-.166.592c-1.277-.232-1.474-.18-1.926 1.418l-1.778 6.27c-.434 1.528-.298 1.694.913 2.15l-.175.61-8.048-2.286c.061-.29.35-1.623.544-2.632l.627.048c.005.702.066 1.25.264 1.654.25.478.675.724 1.628.996l.85.242c.593.166.672.153.83-.408l1.067-3.757-1.378-.39c-1.527-.435-1.725-.325-2.238.706l-.61-.175.96-3.38.61.176c-.14 1.207-.012 1.391 1.52 1.826l1.377.39.764-2.685c.452-1.598.342-1.738-1.102-2.278l.167-.592zm64.442-3.502c3.322-1.207 6.512.395 7.675 3.58 1.036 2.857.026 6.381-3.774 7.764l-.018.004c-3.006 1.093-6.284-.233-7.477-3.52-1.308-3.585.474-6.692 3.594-7.828zm5.248 4.818c-1.031-2.839-3.168-4.783-5.292-4.01-1.575.57-2.295 2.58-1.185 5.634 1.202 3.304 3.27 4.805 5.183 4.112l.013-.005c1.663-.605 2.326-2.856 1.281-5.73zM83.667 223.45l4.498 2.295-.277.549c-1.004-.334-1.176-.185-1.277.636a77.014 77.014 0 0 0-.276 2.102l3.02 1.536c.42-.4.916-.86 1.425-1.396.606-.64.685-.877-.39-1.606l.276-.548 3.528 1.794-.294.545c-1.101-.404-1.382-.33-2.576.728l-7.341 6.446-.908-.201c.394-3.27.811-6.504 1.167-9.73.171-1.658.07-1.97-.856-2.597l.281-.553zm2.54 6.565-.565 3.993.048.026c1.027-.925 1.997-1.86 2.975-2.769l-2.457-1.25zm103.648-10.699.294.54c-1.093.733-1.172.917-.466 2.22l3.23 5.947c.715 1.32.917 1.351 2.124.838l.294.54-4.656 2.527-.294-.54c1.088-.733 1.172-.917.457-2.238l-3.23-5.946c-.707-1.303-.909-1.334-2.115-.82l-.294-.54 4.656-2.528zm-123.267-7.833.632.557-.272 11.454.04.035 2.619-2.984c1.027-1.172 1.47-1.812 1.782-2.247.447-.64.443-1.093-.505-1.992l.404-.465 3.251 2.852-.408.465c-.79-.601-1.281-.658-1.834-.131-.439.39-1.027.904-2.054 2.075l-2.435 2.774c-.755.864-.953 1.14-.966 1.667-.044.527.171.9.68 1.444l-.403.46-2.458-2.15.04-10.277-.053-.048-2.05 2.339c-1.026 1.167-1.491 1.86-1.803 2.268-.434.628-.355 1.102.57 2.002l-.407.465-3.239-2.84.408-.465c.75.588 1.18.663 1.782.11.404-.377 1.027-.93 2.054-2.098l4.625-5.27zm137.656-3.866.395.47c-1.054 1.048-1.124 1.246-.158 2.396l5.38 6.393.456-.386c1.11-.935 1.229-1.286 1.25-1.672.023-.412-.188-1.022-.578-1.843l.482-.408c.777 1.031 1.527 2.084 2.076 2.795l-.32.272c-.479-.127-.676-.008-1.058.312l-5.433 4.568c-.364.307-.487.544-.5.996l-.325.272a90.817 90.817 0 0 0-2.352-2.497l.465-.434c.755.566 1.317.856 1.764.89.435.053.856-.162 1.637-.82l.623-.522-5.375-6.398c-.966-1.15-1.168-1.115-2.44-.21l-.395-.47 4.406-3.704zM51.356 196.063c.364.302 1.624 1.382 2.348 2.339 2.839 3.743 1.588 7.148-.65 8.846-2.887 2.186-6.582 1.488-9.132-1.873-.864-1.141-1.36-2.405-1.562-2.853a53.65 53.65 0 0 1 2.063-2.071l.495.448c-1.325 1.733-.996 3.19-.175 4.274 1.545 2.04 4.327 1.707 6.398.136 2.59-1.962 3.239-4.647 1.786-6.56-.882-1.168-2.29-1.475-4.257-1.115l-.149-.663c.816-.33 2.164-.777 2.835-.908zm89.949-16.747c.033.517.155 2.401.298 4.303l.042.543c.035.45.071.895.107 1.315l-1.417.285c-.448-1.544-.93-2.72-1.62-3.488-.85-.895-1.948-1.176-4.216-1.176h-2.032c-1.418 0-1.58.079-1.58 1.417v8.965h3.287c3.65 0 4.015-.364 4.502-2.962h1.453v8.07h-1.453c-.447-2.76-.851-3.085-4.502-3.085h-3.287v6.645c.015 3.59.398 3.827 3.853 4.107v1.413h-12.647v-1.413c2.958-.286 3.366-.527 3.366-4.34v-15.203c-.02-3.425-.474-3.703-3.366-3.939v-1.457zm77.88 10.722.475.394c-.615 1.005-.593 1.29.206 2.673l4.867 8.47-.378.85c-3.124-1.03-6.214-2.084-9.307-3.067-1.593-.496-1.914-.456-2.717.33l-.482-.387 3.137-3.958.483.382c-.522.917-.413 1.119.373 1.378.527.193 1.273.443 2.005.684l2.102-2.655c-.307-.496-.662-1.07-1.084-1.672-.513-.724-.728-.847-1.654.066l-.483-.386 2.458-3.102zm1.313 5.906-1.712 2.164 3.8 1.342.036-.043c-.702-1.185-1.426-2.322-2.124-3.463zM41.153 179.646l2.484 5.174-.54.259c-.759-1.3-.939-1.387-2.374-.702l-1.768.851c-.395.189-.527.33-.76.619-.666.851-1.452 1.953-2.667 3.708-.768 1.097-.812 1.448-.518 2.387l-.558.268-2.185-4.555.557-.268c.645.983.847.869 1.282.307.83-1.084 1.702-2.286 2.584-3.475-1.127-.022-3.014-.119-4.173-.035-.759.052-.956.166-.548 1.421l-.558.268-1.773-3.695.558-.263c.597.965 1.04 1.145 2.25 1.264 1.225.14 2.107.223 3.981.285.535.017.742 0 1.238-.237l2.036-.979c1.435-.689 1.465-.864.913-2.343l.54-.259zm148.697-106.4 1.294 1.29-58.112 58.114 58.114 58.115-1.295 1.294-58.112-58.115-58.113 58.115-1.29-1.294 58.11-58.114-58.113-58.114 1.295-1.29 58.111 58.111 58.11-58.111zm39.411 97.676.549.281c-.522 1.299-.496 1.51.842 2.19l6.017 3.063c1.351.689 1.518.597 2.198-.465l.549.28-2.41 4.735c-1.004 1.966-2.172 3.296-3.668 3.823-1.132.39-2.563.434-4.042-.316-1.922-.979-2.896-2.445-3.216-4.117-.29-1.61.118-3.462 1.123-5.432l2.058-4.042zm.413 4.63c-1.132-.58-1.646-.544-2.207.557-1.071 2.11-.08 4.441 2.725 5.867 1.492.764 2.922.913 3.993.566.979-.333 1.733-.996 2.282-2.067.285-.57.329-.965.285-1.105-.07-.215-.325-.382-.781-.615zm5.762-26.343.596.167c-.206.974-.043 1.44.667 1.716.545.228 1.264.54 2.756.965l3.555 1.005c1.101.316 1.435.373 1.917.162.496-.193.742-.544 1.014-1.237l.593.167-.891 3.142-9.303 4.375-.018.07 3.265.923c1.322.365 2.08.479 2.55.578.754.123 1.145-.154 1.566-1.374l.593.167-1.176 4.147-.593-.171c.21-.93.092-1.348-.667-1.655-.513-.202-1.281-.53-2.778-.956l-6.744-1.91.232-.815 10.466-4.67.013-.052-3.822-1.084c-1.496-.421-2.269-.549-2.79-.645-.773-.128-1.181.07-1.585 1.312l-.592-.167 1.176-4.16zm-207.75-4.406c.869.14 2.25.457 2.9.69.154.442.676 2.022.803 3.216.496 4.669-2.334 6.942-5.125 7.24-3.603.382-6.407-2.124-6.855-6.319-.149-1.422.08-2.76.136-3.247.948-.259 1.743-.47 2.835-.711l.193.636c-2.031.803-2.501 2.22-2.356 3.572.272 2.546 2.826 3.695 5.41 3.419 3.23-.342 5.17-2.308 4.915-4.696-.153-1.457-1.202-2.448-3.071-3.155zm160.083-23.768c3.528 0 5.595.404 7.219 1.536 1.62 1.058 2.751 2.883 2.751 5.398 0 3.568-2.347 5.476-5.064 6.613.57 1.172 2.107 3.888 3.283 5.753 1.461 2.234 2.312 3.528 3.12 4.38.895.934 1.54 1.421 2.475 1.746l-.242 1.295c-.245 0-.732-.044-1.22-.044-5.103-.242-6.683-1.378-8.306-3.932-1.054-1.663-2.15-3.853-3.331-5.96-.645-1.259-1.378-1.746-2.673-1.785h-.772v6.151c.02 3.118.474 3.51 3.445 3.788v1.413h-12.24v-1.413c3.042-.285 3.49-.689 3.49-4.015v-15.574c0-3.243-.369-3.651-3.327-3.932v-1.418zm-110.651.001c.044.69.246 3.81.447 6.161l-1.417.286c-.448-1.545-.93-2.721-1.62-3.49-.85-.894-1.948-1.175-4.216-1.175H68.28c-1.418 0-1.58.079-1.58 1.417v8.966h3.287c3.651 0 4.015-.365 4.502-2.963h1.453v8.07h-1.453c-.447-2.76-.851-3.084-4.502-3.084H66.7v6.645c.015 3.59.398 3.827 3.853 4.106v1.413H57.906v-1.413c2.958-.285 3.366-.527 3.366-4.34v-15.203c-.02-3.425-.474-3.703-3.366-3.939v-1.457zm169.995 6.28.614.022-.197 5.31-.615-.022c-.074-1.295-.193-1.475-1.851-1.536l-3.831-.145c-2.651-.097-4.222.799-4.292 2.703-.08 2.102 1.479 3.08 4.423 3.19l1.892.07c1.25.049 1.926-.017 2.457-.083.623-.066.992-.478 1.106-1.676l.619.022-.167 4.428-.615-.022c-.017-.97-.373-1.426-.987-1.536-.544-.11-1.194-.206-2.449-.25l-1.922-.075c-1.873-.07-3.343-.404-4.366-1.43-.816-.847-1.211-2.063-1.163-3.318.044-1.163.33-2.264 1.031-3.09.812-.974 2.137-1.382 4.2-1.307l4.151.153c1.66.062 1.79-.11 1.962-1.408zm-59.914-4.661c-1.014 0-1.58.162-1.826.403-.285.246-.364.65-.364 1.501v9.9h1.053c1.707 0 3.085-.285 3.98-1.097 1.378-1.137 1.944-2.756 1.944-4.827 0-4.3-2.514-5.88-4.787-5.88zm-168.764 4.068c.272-3.185 2.848-5.608 6.332-5.31 3.805.325 5.876 3.244 5.596 6.557-.303 3.52-3.094 5.74-6.473 5.454-3.028-.259-5.802-2.655-5.46-6.683zm6.6-2.575c-3.506-.299-5.74.943-5.91 2.97v.018c-.15 1.76 1.614 3.309 4.66 3.568 3.01.259 5.674-.865 5.867-3.116.14-1.672-1.378-3.168-4.617-3.44zM238.45 103.76c3.006-.466 6.267 1.206 6.886 5.204l.004.018c.491 3.16-1.444 6.117-4.897 6.657-3.77.583-6.477-1.764-6.986-5.042-.545-3.494 1.645-6.315 4.993-6.837zm6.122 4.98c-.272-1.746-2.352-2.835-5.371-2.365-2.989.465-5.31 2.185-4.963 4.419.259 1.659 2.088 2.751 5.3 2.251 3.472-.54 5.35-2.277 5.038-4.287zm-212.906-6.766c.676.337 2.273 1.176 2.69 1.443l-2.348 8.272-.592-.17c.302-1.51.232-1.717-1.198-2.12l-6.508-1.844c-1.461-.416-1.61-.276-2.098.983l-.592-.17 1.474-5.196.593.166c-.25 1.343-.193 1.527 1.268 1.94l6.63 1.882c.8.224 1.124.242 1.379-.07.197-.254.364-.702.513-1.228.202-.716.255-1.36-.088-1.9-.263-.422-.72-.883-1.479-1.449zm204.222-19.59 3.243 7.715c-.268.136-1.488.741-2.396 1.22l-.356-.522c.544-.44.935-.83 1.128-1.238.215-.491.145-.978-.241-1.891l-.343-.816c-.237-.57-.298-.62-.838-.395l-3.598 1.514.557 1.32c.614 1.466.825 1.55 1.948 1.308l.246.584-3.238 1.36-.246-.584c1.031-.645 1.093-.86.478-2.33l-.557-1.316-2.572 1.08c-1.531.644-1.575.816-1.092 2.281l-.57.237-2.134-5.077.567-.237c.614 1.141.78 1.26 2.312.619l6.008-2.528c1.465-.614 1.51-.825 1.11-2.058l.584-.246zm-205.68-.724c1.594-2.773 4.95-3.88 7.988-2.141 3.308 1.895 3.953 5.42 2.303 8.302-1.755 3.063-5.226 3.902-8.17 2.216-2.634-1.51-4.139-4.849-2.129-8.36zm7.075.448c-3.054-1.747-5.604-1.558-6.613.202l-.01.017c-.877 1.532.071 3.682 2.722 5.2 2.62 1.505 5.511 1.61 6.635-.35.834-1.458.083-3.454-2.734-5.07zM135.79 59.98c3.287 0 6.284.852 7.381 1.097.364 2.23.65 4.095.93 6.644l-1.5.285c-1.334-4.827-4.459-6.244-7.583-6.244-5.876 0-9.124 5.556-9.124 11.515 0 7.464 4.016 12.37 9.532 12.37 3.366 0 5.88-2.15 7.947-6.244l1.417.65c-.526 1.948-1.58 5.028-2.268 6.446-1.054.241-4.784 1.049-7.544 1.049-10.782 0-15.28-7.009-15.28-13.46 0-8.31 6.403-14.108 16.092-14.108zm-90.06-.024c.811-.228 1.733-.075 2.558.645 1.167 1.027 1.119 2.343.71 3.559.545.149 1.879.425 2.827.579 1.15.162 1.816.255 2.33.237.561-.026.908-.097 1.281-.312l.356.452c-.07.08-.224.229-.365.387-1.544 1.601-2.374 1.794-3.673 1.588-.847-.132-1.878-.4-2.91-.619-.596-.149-.964-.052-1.35.365l-.224.25 1.94 1.702c1.092.957 1.338.94 2.307.027l.461.403-3.515 4.007-.465-.404c.781-1.08.777-1.343-.312-2.295l-5.099-4.472c-1.062-.934-1.299-.93-2.242-.043l-.465-.404 3.273-3.73c1.014-1.159 1.743-1.72 2.576-1.922zm167.11-9.812 3.405 4.05-.47.4c-.913-.896-1.084-.935-2.233.03l-1.993 1.672 3.107 3.69 1.988-1.671c1.15-.966 1.141-1.141.39-2.22l.474-.396 3.41 4.05-.474.4c-.978-.974-1.132-.988-2.277-.022l-5.21 4.375c-1.131.957-1.123 1.132-.355 2.238l-.47.395-3.466-4.12.47-.396c1.005 1.001 1.18 1.019 2.317.062l2.514-2.115-3.102-3.69-2.515 2.114c-1.15.966-1.14 1.141-.395 2.22l-.47.4-3.387-4.028.47-.4c.925.909 1.11.961 2.26-.004l5.19-4.362c1.15-.97 1.129-1.158.347-2.277l.474-.395zM46.822 62.65c-1.409-1.237-2.65-.869-3.304-.123-.29.334-.4.566-.391.716 0 .162.11.302.386.548l3.243 2.844.303-.347c.487-.557.794-1.088.781-1.615.026-.777-.342-1.43-1.018-2.023zm143.826-22.49c2.247-2.839 5.999-3.085 9.307-.465 1.124.89 1.918 1.992 2.225 2.37-.478.86-.886 1.575-1.479 2.523l-.588-.312c.847-2.01.163-3.335-.904-4.182-2.005-1.588-4.616-.57-6.227 1.466-2.018 2.55-1.974 5.31-.092 6.802 1.15.908 2.59.856 4.402.017l.311.602c-.706.522-1.9 1.29-2.519 1.588-.425-.202-1.917-.934-2.86-1.68-3.683-2.914-3.323-6.526-1.576-8.729zM73.726 35.766l.173.006c.842.026 1.676.448 2.246 1.382.812 1.33.37 2.572-.381 3.607.474.308 1.663.97 2.523 1.396 1.049.5 1.659.79 2.155.921.544.145.895.18 1.316.088l.202.536c-.092.057-.28.149-.46.263-1.958 1.066-2.8 1-3.985.421-.768-.382-1.672-.948-2.59-1.461-.526-.32-.908-.338-1.4-.057l-.285.175 1.343 2.199c.755 1.237.996 1.299 2.194.715l.32.522-4.55 2.778-.32-.526c1.066-.795 1.136-1.045.381-2.282l-3.528-5.793c-.737-1.207-.965-1.273-2.128-.706l-.32-.527 4.234-2.585c1.312-.798 2.173-1.119 3.033-1.066zm.41 2.902c-.975-1.597-2.27-1.615-3.116-1.101-.377.232-.549.421-.584.566-.052.153.01.325.202.64l2.247 3.682.39-.241c.632-.386 1.084-.803 1.23-1.308.258-.733.1-1.465-.37-2.238zm98.727-13.235 4.529 2.032c1.4.632 2.15 1.158 2.593 1.9.457.707.58 1.632.132 2.633-.636 1.417-1.909 1.755-3.19 1.725.017.566.145 1.922.276 2.87.18 1.15.29 1.816.46 2.299.185.531.356.838.672 1.132l-.329.47c-.096-.04-.28-.145-.474-.233-1.988-1.005-2.413-1.738-2.602-3.04-.123-.852-.167-1.919-.259-2.963-.035-.619-.237-.94-.746-1.19l-.307-.135-1.053 2.352c-.597 1.32-.505 1.558.654 2.212l-.255.561-4.862-2.18.25-.562c1.26.425 1.51.346 2.102-.975l2.778-6.187c.579-1.29.504-1.518-.619-2.16l.25-.56zm-78.124-.311c.053.126.18.414.343.782l.147.333.58 1.311-.57.299c-.378-.518-.79-.988-1.198-1.18-.39-.198-.882-.15-1.808.188l-.799.29c-.614.223-.671.28-.47.829l1.282 3.52 1.11-.404c1.396-.505 1.58-.667 1.391-1.914l.597-.22 1.216 3.354-.593.215c-.667-1.11-.89-1.102-2.304-.588l-1.11.403 1.045 2.87c.28.781.5 1.172.89 1.22.347.022.926-.149 1.558-.377.847-.312 1.4-.64 1.646-1.203.184-.478.29-1.119.338-1.966l.623-.092c.171.781.373 2.418.421 2.962l-8.465 3.077-.21-.58c1.369-.627 1.5-.785.987-2.198l-2.317-6.372c-.527-1.448-.724-1.47-1.935-1.14l-.21-.58zm60.87-4.63c.399 3.265.772 6.503 1.202 9.724.232 1.65.404 1.927 1.457 2.313l-.14.601-4.92-1.14.14-.602c1.05.079 1.185-.105 1.084-.926a72.453 72.453 0 0 0-.237-2.106l-3.3-.768c-.316.491-.68 1.057-1.048 1.698-.435.768-.452 1.018.763 1.466l-.136.6-3.857-.899.158-.592c1.167.123 1.417-.018 2.321-1.33l5.582-8.021zm21.27 7.513c-.404-.18-.659-.215-.8-.163-.157.044-.263.193-.412.531l-1.768 3.932.421.189c.676.303 1.277.439 1.777.276.75-.206 1.264-.75 1.633-1.57.768-1.712.048-2.787-.852-3.195zM111.9 20.189c1.12-.171 2.168.022 2.501.097.167.632.409 1.382.72 2.44l-.575.232c-.535-1.044-1.382-2.233-2.813-2.01-.978.15-1.58.996-1.426 1.988.15.961.865 1.422 2.523 1.953 1.97.606 3.375 1.387 3.647 3.116.307 1.988-1.14 3.804-3.69 4.2a6.384 6.384 0 0 1-1.8.03 8.72 8.72 0 0 1-1.123-.22c-.228-.412-.68-1.842-.97-2.887l.584-.285c.522 1.062 1.852 2.857 3.528 2.598 1.066-.167 1.632-1.005 1.461-2.107-.158-1.03-1.027-1.558-2.444-2.049-1.94-.628-3.326-1.378-3.585-3.054-.299-1.922.983-3.656 3.462-4.042zm15.873-1.896 8.307.308c.008.316.048 1.553.079 2.655l-.637.06c-.153-.622-.364-1.215-.667-1.544-.285-.329-.759-.47-1.746-.504l-.852-.035c-.653-.022-.724.008-.746.592l-.14 3.743 1.185.044c1.483.057 1.716-.026 2.01-1.25l.632.021-.132 3.564-.632-.022c-.202-1.282-.413-1.36-1.913-1.413l-1.18-.044-.115 3.054c-.03.83.022 1.273.369 1.461.311.154.913.21 1.584.237.9.035 1.54-.066 1.979-.491.347-.378.689-.93 1.053-1.694l.61.145c-.136.79-.566 2.383-.724 2.905l-9-.334.022-.614c1.505-.07 1.685-.167 1.742-1.668l.254-6.78c.057-1.535-.118-1.628-1.364-1.781l.022-.615zm25.847 5.051c-.773 1.146-1.492 2.287-2.22 3.401l2.68.623-.408-4.01z"
              fill="#020F45"
              fillRule="evenodd"
            />
          </svg>
          <span>fcresearch.org</span>
        </div>
      </div>
    </>
  );
};
